<ion-header>
  <ion-toolbar style="padding-right: 15px">
    <div class="flex-space-between">
      <div class="flexed">
        <ion-list class="no-padding transparent-bg">
          <ion-item class="transparent-bg">
            <ion-label position="stacked"> Report Type </ion-label>
            <ion-select
              placeholder="Select Report Type"
              [(ngModel)]="chartType"
              interface="popover"
              (ionChange)="onChartTypeChange()"
              style="
                font-size: 1rem;
                font-weight: 600;
                padding-bottom: 10px;
                margin-right: 10px;
                color: var(--ion-color-primary);
              "
            >
              <ion-select-option [value]="CHART_TYPES[0]">Conversation Created</ion-select-option>
              <ion-select-option [value]="CHART_TYPES[1]">First Response Time (Avg)</ion-select-option>
              <ion-select-option [value]="CHART_TYPES[2]">First Response Time (Median)</ion-select-option>
              <ion-select-option [value]="CHART_TYPES[3]">First Response Time (P95)</ion-select-option>
              <ion-select-option [value]="CHART_TYPES[4]">First Response Time (P99)</ion-select-option>
              <ion-select-option [value]="CHART_TYPES[5]">Resolution Time (Avg)</ion-select-option>
              <ion-select-option [value]="CHART_TYPES[6]">Resolution Time (Median)</ion-select-option>
              <ion-select-option [value]="CHART_TYPES[7]">Resolution Time (P95)</ion-select-option>
              <ion-select-option [value]="CHART_TYPES[8]">Resolution Time (P99)</ion-select-option>
              <ion-select-option [value]="CHART_TYPES[9]">Resolved Conversations</ion-select-option>
              <ion-select-option [value]="CHART_TYPES[10]">Sentiment Score</ion-select-option>
              <ion-select-option [value]="CHART_TYPES[11]">Waiting on Agent Time (Avg)</ion-select-option>
              <ion-select-option [value]="CHART_TYPES[12]">Waiting on Agent Time (Median)</ion-select-option>
              <ion-select-option [value]="CHART_TYPES[13]">Waiting on Agent Time (P95)</ion-select-option>
              <ion-select-option [value]="CHART_TYPES[14]">Waiting on Agent Time (P99)</ion-select-option>
              <ion-select-option [value]="CHART_TYPES[15]">Waiting on Customer Time (Avg)</ion-select-option>
              <ion-select-option [value]="CHART_TYPES[16]">Waiting on Customer Time (Median)</ion-select-option>
              <ion-select-option [value]="CHART_TYPES[17]">Waiting on Customer Time (P95)</ion-select-option>
              <ion-select-option [value]="CHART_TYPES[18]">Waiting on Customer Time (P99)</ion-select-option>
            </ion-select>
          </ion-item>
        </ion-list>
      </div>

      <div class="flexed-align-center">
        <ion-button
          color="dark"
          fill="clear"
          class="button-dark-border"
          *ngIf="getSavedReport(savedReportId)"
          (click)="showSavedReportOptions(savedReportId)"
        >
          <ion-icon style="font-size: 0.8rem" name="ellipsis-vertical"></ion-icon>
        </ion-button>
        <ion-button
          color="dark"
          fill="clear"
          class="button-dark-border"
          (click)="openSaveReportModal()"
          [hidden]="savedReportId"
          ngxTippy
          [tippyProps]="{
            arrow: false,
            placement: 'bottom'
          }"
          data-tippy-content="Save report view for future use"
        >
          <ion-icon name="save" class="filter-button-icon"></ion-icon>
          <span class="hidden-sm">Save...</span>
        </ion-button>
        <ion-button
          color="dark"
          fill="clear"
          class="button-dark-border"
          (click)="viewInInbox()"
          ngxTippy
          [tippyProps]="{
            arrow: false,
            placement: 'bottom'
          }"
          data-tippy-content="View conversations in inbox"
        >
          <ion-icon name="file-tray-outline" style="font-size: 1.05rem"></ion-icon>
        </ion-button>
        <ion-button
          color="dark"
          fill="clear"
          class="button-dark-border"
          (click)="copyLink()"
          ngxTippy
          [tippyProps]="{
            arrow: false,
            placement: 'bottom'
          }"
          data-tippy-content="Copy link to report"
        >
          <ion-icon name="link-outline" style="font-size: 1.05rem"></ion-icon>
        </ion-button>
        <ion-button
          color="dark"
          fill="clear"
          class="button-dark-border"
          (click)="downloadCSV()"
          ngxTippy
          [tippyProps]="{
            arrow: false,
            placement: 'bottom'
          }"
          data-tippy-content="Download as a CSV"
        >
          <ion-icon name="cloud-download-outline" style="font-size: 1.05rem"></ion-icon>
        </ion-button>
      </div>
    </div>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col size="12">
        <div class="flexed-align-center">
          <ion-button
            color="dark"
            fill="clear"
            class="button-dark-border btn-small"
            (click)="showDateRangeOptions()"
            [ngClass]="{ 'button-round-left': dateRange.type === 'absolute' }"
          >
            <ion-icon name="calendar" class="filter-button-icon"></ion-icon>
            <span class="hidden-sm">{{ dateRange.label }}</span>
            <ion-icon name="chevron-down-outline" class="filter-button-caret"></ion-icon>
          </ion-button>
          <ion-button
            color="dark"
            fill="clear"
            class="btn-small"
            (click)="changeDate(false)"
            *ngIf="dateRange.type === 'absolute'"
            style="margin-left: 0; margin-right: 0; --padding-end: 6px"
          >
            {{ startDate | date: 'M/d/yyyy' }}
          </ion-button>
          <ion-button
            color="dark"
            fill="clear"
            class="btn-small"
            *ngIf="dateRange.type === 'absolute'"
            disabled="true"
            style="--padding-start: 0; margin: 0; --padding-end: 0"
          >
            –
          </ion-button>
          <ion-button
            color="dark"
            fill="clear"
            class="btn-small"
            (click)="changeDate(true)"
            *ngIf="dateRange.type === 'absolute'"
            style="--padding-start: 6px"
          >
            {{ endDate | date: 'M/d/yyyy' }}
          </ion-button>
          <ion-button
            color="warning"
            class="btn-small"
            *ngIf="isDateRangeInvalid"
            shape="round"
            ngxTippy
            [tippyProps]="{
              arrow: false,
              placement: 'bottom'
            }"
            data-tippy-content="Invalid date range"
          >
            <ion-icon name="warning-outline"></ion-icon>
          </ion-button>
          <ion-button color="dark" fill="clear" class="button-dark-border btn-small" (click)="showGroupByOptions()">
            <ion-icon name="bar-chart" class="filter-button-icon"></ion-icon>
            <span class="hidden-sm">{{ groupByFilterLabel }}</span>
            <ion-icon name="chevron-down-outline" class="filter-button-caret"></ion-icon>
          </ion-button>
          <app-filter-button
            [options]="filterOptions"
            (didChange)="filtersDidChange($event)"
            [selected]="filters"
            [projectId]="authService.selectedProject?.id ?? undefined"
          ></app-filter-button>
        </div>

        <ion-card class="outline-card">
          <div style="margin: 15px 10px" class="hidden-sm">
            <p style="font-size: 0.8rem; opacity: 0.5; margin-left: 5px"><strong>Results</strong> broken down by:</p>
            <ng-container *ngFor="let report of DIMENSION_OPTIONS">
              <span
                *appVar="tabIsActive(report) as isTabActive"
                class="tab-nav-link"
                [ngClass]="{ 'tab-nav-active': isTabActive }"
                (click)="setDimension(report, $event)"
                style="font-size: 0.7rem"
              >
                <ion-icon [name]="isTabActive ? report.icon : report.icon + '-outline'"></ion-icon>
                {{ report.label }}
              </span>
            </ng-container>
          </div>
          <ion-card-content>
            <div style="position: relative; height: 520px; width: 100%; margin: auto">
              <canvas #chart baseChart [datasets]="chartData" [labels]="chartLabels" [options]="chartOptions"> </canvas>
            </div>
          </ion-card-content>
        </ion-card>
        <div style="text-align: center">
          <ion-button color="dark" fill="clear" class="btn-small fake-button" [disabled]="true">
            Chart options:
          </ion-button>
          <ion-button
            color="dark"
            fill="clear"
            class="btn-small"
            (click)="changeUnit()"
            *ngIf="
              chartType === CHART_TYPES[1] ||
              chartType === CHART_TYPES[2] ||
              chartType === CHART_TYPES[3] ||
              chartType === CHART_TYPES[4] ||
              chartType === CHART_TYPES[5] ||
              chartType === CHART_TYPES[6] ||
              chartType === CHART_TYPES[7] ||
              chartType === CHART_TYPES[8]
            "
          >
            <ion-icon name="timer-outline" class="padded-icon checkbox-icon"> </ion-icon>
            {{ unit.label }}
            <ion-icon name="chevron-down-outline" class="filter-button-caret"></ion-icon>
          </ion-button>
          <ion-button color="dark" fill="clear" class="btn-small" (click)="showChartStyleOptions()">
            <ion-icon [name]="chartStyle === 'bar' ? 'stats-chart' : 'analytics'" class="filter-button-icon"></ion-icon>
            <span style="font-weight: 600">{{ chartStyle === 'bar' ? 'Bar' : 'Line' }}</span>
            <ion-icon name="chevron-down-outline" class="filter-button-caret"></ion-icon>
          </ion-button>
          <ion-button class="btn-small hidden-sm" fill="clear" color="dark" (click)="toggleLegendShowing()">
            <ion-icon
              [name]="shouldShowLegend ? 'checkmark-circle' : 'ellipse-outline'"
              class="padded-icon checkbox-icon"
            >
            </ion-icon>
            Show legend
          </ion-button>
          <ion-button
            class="btn-small"
            fill="clear"
            color="dark"
            (click)="toggleChartSmoothing()"
            [hidden]="chartStyle === 'bar'"
          >
            <ion-icon
              [name]="chartSmoothingEnabled ? 'checkmark-circle' : 'ellipse-outline'"
              class="padded-icon checkbox-icon"
            >
            </ion-icon>
            Line smoothing
          </ion-button>
          <ion-button class="btn-small" fill="clear" color="dark" (click)="toggleBusinessHoursOnly()">
            <ion-icon
              [name]="businessHoursOnly ? 'checkmark-circle' : 'ellipse-outline'"
              class="padded-icon checkbox-icon"
            >
            </ion-icon>
            Working hours only
          </ion-button>
        </div>
      </ion-col>
      <ion-col size="12">
        <ion-card class="outline-card">
          <ion-card-title class="card-title">
            <h3>Results</h3>
          </ion-card-title>
          <ngx-datatable
            class="material"
            [limit]="100"
            [headerHeight]="50"
            [footerHeight]="50"
            [rowHeight]="50"
            [scrollbarH]="true"
            [rows]="tabularDataWithTotals"
            [reorderable]="true"
            [rowClass]="getRowClass"
          >
            <ngx-datatable-column
              name="{{ dimensionKey !== 'overall' ? dimensionLabel : '' }}"
              prop="dimensionLabel"
              [sortable]="false"
              [frozenLeft]="true"
              [width]="250"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                <ion-icon
                  *ngIf="row.dimensionData?.icon"
                  [name]="row.dimensionData.icon"
                  [class]="row.dimensionData.iconClass"
                  style="margin-right: 5px"
                ></ion-icon>
                {{ row.dimensionData?.value ?? getYAxisLabel() }}
              </ng-template>
            </ngx-datatable-column>
            <ng-container>
              <ngx-datatable-column
                *ngFor="let column of columns"
                [name]="getColumnName(column)"
                [prop]="column"
                [sortable]="true"
                [width]="115"
              >
                <ng-template let-value="value" ngx-datatable-cell-template>
                  {{ value | number }}
                </ng-template>
              </ngx-datatable-column>
            </ng-container>
            <ngx-datatable-column name="Total" prop="total" [sortable]="true" [width]="115" *ngIf="showTotalColumn">
              <ng-template let-value="value" ngx-datatable-cell-template>
                {{ value | number }}
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-modal [isOpen]="showSaveReportModal" class="saved-report-modal" (willDismiss)="onDismissSaveReportModal()">
  <ng-template>
    <ion-header class="modal-header">
      <ion-toolbar>
        <div class="modal-title">
          <h3>Create Saved Report</h3>
        </div>
        <ion-buttons slot="end">
          <ion-button fill="clear" shape="round" class="close-button" (click)="onDismissSaveReportModal()">
            <ion-icon name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding">
      <ion-input [(ngModel)]="savedReportName" class="input-field" placeholder="Name your saved report"> </ion-input>
      <ion-list class="transparent-bg">
        <ion-item>
          <ion-label> Share this report with your team? </ion-label>
          <label class="switch" slot="end">
            <input type="checkbox" [(ngModel)]="savedReportShouldShare" />
            <span class="slider"></span>
          </label>
        </ion-item>
      </ion-list>
    </ion-content>
    <ion-footer>
      <div style="padding: 15px">
        <ion-button (click)="saveReport()" class="save-button" [disabled]="!savedReportName || isSaving">
          Save
        </ion-button>
        <ion-button fill="clear" color="dark" (click)="onDismissSaveReportModal()"> Cancel </ion-button>
      </div>
    </ion-footer>
  </ng-template>
</ion-modal>
